import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <Header />
      <main className="flex-grow flex items-center justify-center py-20 px-4">
        <div className="max-w-xl w-full text-center bg-white rounded-2xl shadow-sm p-10 md:p-16 border border-slate-100">
          <div className="bg-red-50 text-red-500 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-slate-800 mb-4">Page Not Found</h2>
          <p className="text-gray-600 mb-8 text-lg">
            Sorry, the page you are looking for doesn't exist or has been moved.
          </p>
          <a 
            href="/" 
            className="inline-flex items-center justify-center px-8 py-3.5 text-base font-bold text-white transition-all duration-300 rounded-lg shadow-md hover:scale-[1.02]"
            style={{ background: 'linear-gradient(135deg, #0C4288 0%, #1571BA 100%)' }}
          >
            Return to Homepage
          </a>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFoundPage;
